<template lang="pug">
    .container.content(ref="container")
        .image(:style="{ width: `${width}px`, height: `${height}px` }")
            figure(v-if="image")
                img(
                    v-lazy="image"
                    :title="title || subTitle"
                    :style="{ width: `${width}px`, height: `${height}px` }"
                    rel="noopener"
                    :alt="image.imageName"
                )
            p(v-if="title") {{ title }}
            small(v-if="subTitle") {{ subTitle }}
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import min from 'lodash.min'
import trim from 'lodash.trim'
import debounce from 'lodash.debounce'

export default {
    name: 'ImageSection',
    data() {
        return {
            maxW: undefined,
            // aspectRatio: undefined,
            // w: undefined,
            // h: undefined,
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    computed: {
        content() {
            return get(this.section, 'contents.0')
        },
        title() {
            return get(this.content, 'title')
        },
        subTitle() {
            return get(this.content, 'sub_title')
        },
        width() {
            if (this.image.width && this.maxW) return min([this.image.width, this.maxW])
            else return this.maxW
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio
            else return undefined
        },
        image() {
            const image = get(this.content, 'images.0')
            if (! image || ! this.maxW) return false

            const storageRoute = trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                ... get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ... get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ... get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h, fz } = parameters
            if (! fz) fz = 1

            let width, height, aspectRatio

            width = image.width / fz
            height = image.height / fz
            aspectRatio = width / height

            if (w && h) {
                aspectRatio = w / h
                height = Math.min(this.maxW, width) / aspectRatio

                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&w=${Math.min(this.maxW, width)}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                imageName: image.name.substring(0, image.name.lastIndexOf('.')),
                width,
                height,
                aspectRatio,
            }
        },
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.maxW = this.$refs.container.clientWidth
                this.maxW -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
            }
        }

        window.addEventListener('resize', debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'

    .content
        display: flex
        flex-direction: column
        align-items: center
        max-width: 100%
        .image
            figure
                display: block
                margin-bottom: 2px
                img
                    width: auto
                    height: initial
                    border-radius: 4px
                    display: inline-block
                    &[lazy=loading]
                        box-shadow: none
                    &[lazy=loaded]
                        // max-height: 500px
                        // height: initial !important
                        // width: initial !important
                        box-shadow: $box-shadow-3
            p
                margin-bottom: 0
                font-size: .8rem
            small
                font-size: .65rem
                display: block

    .container.content
        background: $skeletonColor
</style>
